'use client'

import type { FC } from 'react'
import { type CategoryDTO, type Currency, type Option } from 'ecosystem'
import { useSelector } from 'shared-redux'
import { selectedProductState } from 'shared-redux/state'
import { useTrackViewItemList } from './use-track-view-item-list'

interface ListAnalyticsTrackerProps {
  id: string
  categories: Option<CategoryDTO[]>
  currency: Currency
  name: string
  isLoading?: boolean
}

const ListAnalyticsTracker: FC<ListAnalyticsTrackerProps> = ({
  id,
  categories,
  currency,
  isLoading,
  name
}) => {
  const productsState = useSelector(selectedProductState)

  useTrackViewItemList({
    categories,
    id,
    products: productsState.content ?? undefined,
    currency,
    listName: name,
    isLoading: isLoading || productsState.productsListId !== id
  })

  return null
}

export default ListAnalyticsTracker
